import { render } from "./menufunc.vue?vue&type=template&id=1a377a6e&scoped=true"
import script from "./menufunc.vue?vue&type=script&lang=js"
export * from "./menufunc.vue?vue&type=script&lang=js"

import "./menufunc.vue?vue&type=style&index=0&id=1a377a6e&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a377a6e"]])

export default __exports__